<template>
<section class="premium-section">
<h2 class="section-title">MDR Vesting Allocation and Token Claim Process</h2>

<p>
After the reward snapshot is executed, finalized token allocations are transferred to the Mudra Vesting Smart Contract.
</p>

<p>
The vesting contract securely manages the release of MDR tokens to creators over time.
</p>

<p>
Creators can access their allocated tokens by interacting with the vesting smart contract using compatible blockchain wallets such as MetaMask.
</p>

<p>
The smart contract calculates the claimable amount based on the vesting schedule and allows users to claim their tokens directly on-chain.
</p>

<p>
This mechanism ensures transparent and verifiable token distribution for all creators participating in the Mudra ecosystem.
</p>

</section>
</template>